import { useCallback } from 'react';
import useGustoAxios from '../../useGustoAxios/useGustoAxios';

export default function useGustoDeleteToken() {
  const axios = useGustoAxios();
  return useCallback(() => {
    return axios.delete('/oauth/token');
  }, [axios]);
}
